import { Utils } from "@/lib/utils";
import { User } from "@prisma/client";
import { useMemo } from "react";
import { Avatar, AvatarFallback, AvatarImage } from "../ui/avatar";
interface FeedPostAuthorProps {
      author: User
}

const FeedPostAuthor = ({ author }: FeedPostAuthorProps) => {
      const imageUrl = useMemo(() => {
            return Utils.image.getUserImageUrl(author.image || "");
      }, [author.image]);

      return <div className="flex items-center gap-2 text-left">
            <Avatar className="h-5 w-5">
                  <AvatarImage src={imageUrl || ""} alt={author.name ?? ""} />
                  <AvatarFallback>{author.name?.charAt(0)}</AvatarFallback>
            </Avatar>
            <div className="flex flex-col">
                  <span className="text-sm font-medium">{author.name}</span>
            </div>
      </div>
}

export default FeedPostAuthor;
